const routes = {
  path: '/equipment',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/equipment',
      name: 'list-equipment',
      component: () => import('../views/Equipment/Index.vue'),
      meta: {
        pageTitle: 'Equipamentos',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Equipamentos', active: true }],
      },
    },
    {
      path: '/equipment/allocations',
      name: 'list-equipment-allocations',
      component: () => import('../views/Equipment/Allocations.vue'),
      meta: {
        pageTitle: 'Equipamentos em uso',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Equipamentos em uso', active: true }],
      },
    },
    {
      path: '/equipment/:id/history',
      name: 'equipment-history',
      component: () => import('../views/Equipment/History.vue'),
      meta: {
        pageTitle: 'Histórico do equipamento',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'Equipamentos', to: { name: 'list-equipment' } },
          { text: 'Histórico', active: true },
        ],
      },
    },
    {
      path: '/equipment/types',
      name: 'list-equipment-types',
      component: () => import('../views/Equipment/Types.vue'),
      meta: {
        pageTitle: 'Tipos de equipamento',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Tipos de equipamento', active: true }],
      },
    },
  ],
}

export default routes
